import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NotesApp from './components/NotesApp';
import LoginPage from './components/home/LoginPage';
import HomePage from './components/home/HomePage';
import ProtectedRoute from './components/ProtectedRoute';
import { ThemeProvider } from './components/contexts/ThemeContext';
import { CategoriesProvider } from './components/contexts/CategoriesContext';
import { WorkspacesProvider } from './components/contexts/WorkspacesContext';  // ✅ CORRECT
import RegisterPage from './components/home/RegisterPage';
import RegistrationSuccess from './components/home/RegistrationSuccess';
import EmailVerification from './components/home/EmailVerification';
import RequestResetPage from './components/home/RequestResetPage';
import ResetPasswordPage from './components/home/ResetPasswordPage';
import PaymentPage from './components/home/PaymentPage'; // or wherever you put it
import PaymentSuccess from './components/home/PaymentSuccess';
import CancellationPage from './components/home/CancellationPage';
// App.js - Add this import


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Home page route */}
        <Route 
          path="/" 
          element={
            <ThemeProvider>
              <HomePage />
            </ThemeProvider>
          } 
        />

        {/* Registration routes */}
        <Route 
          path="/signup" 
          element={
            <ThemeProvider>
              <RegisterPage />
            </ThemeProvider>
          }
        />

        {/* Login route */}
        <Route 
          path="/login" 
          element={
            <ThemeProvider>
              <LoginPage />
            </ThemeProvider>
          }
        />

        {/* Registration Success route */}
        <Route 
          path="/registration-success" 
          element={
            <ThemeProvider>
              <RegistrationSuccess />
            </ThemeProvider>
          }
        />

        {/* Email Verification route */}
        <Route 
          path="/verify-email" 
          element={
            <ThemeProvider>
              <EmailVerification />
            </ThemeProvider>
          }
        />

        <Route 
            path="/upgrade" 
            element={
              <ThemeProvider>
                <PaymentPage />
              </ThemeProvider>
            }
          />


          <Route 
  path="/payment-success" 
  element={
    <ThemeProvider>
      <PaymentSuccess />
    </ThemeProvider>
  }
/>

{/* ADD THIS - Protected Cancellation Route */}
<Route 
  path="/cancel-subscription" 
  element={
    <ThemeProvider>
      <CategoriesProvider>
        <WorkspacesProvider>
          <ProtectedRoute>
            <CancellationPage />
          </ProtectedRoute>
        </WorkspacesProvider>
      </CategoriesProvider>
    </ThemeProvider>
  }
/>

      {/* Password Reset routes */}
      <Route 
        path="/forgot-password" 
        element={
          <ThemeProvider>
            <RequestResetPage />
          </ThemeProvider>
        }
      />

      <Route 
        path="/reset-password" 
        element={
          <ThemeProvider>
            <ResetPasswordPage />  {/* CHANGE TO THIS */}
          </ThemeProvider>
        }
      />
{/* Dashboard route */}
<Route 
  path="/dashboard" 
  element={
    <ThemeProvider>
      <CategoriesProvider>
        <WorkspacesProvider>
          <ProtectedRoute>
            <NotesApp />
          </ProtectedRoute>
        </WorkspacesProvider>
      </CategoriesProvider>
    </ThemeProvider>
  } 
/>
         {/* Protected notes route - Update this section */}
         <Route 
          path="/notes/:publicId" 
          element={
            <ThemeProvider>
              <CategoriesProvider>
                <WorkspacesProvider>
                  <ProtectedRoute>
                    <NotesApp />
                  </ProtectedRoute>
                </WorkspacesProvider>
              </CategoriesProvider>
            </ThemeProvider>
          } 
        />

        {/* Catch all other routes and redirect to login */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;